import React, {PropTypes} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import {push} from 'react-router-redux';
import {I18n} from 'react-redux-i18n';

import customer from '../../customer';
const {isMasterUser} = customer.selectors;

import {getAllUsers, selectUser} from '../actions';
import {getUsers, areUsersValid} from '../selectors';

import UserTable from './UserTable';

class UsersPage extends React.Component {
  componentWillMount() {
    if(!this.props.isMasterUser)
    {
      this.props.actions.push('/labels');
    } 

    if(!this.props.userListValid) {
      this.props.actions.getAllUsers();
    }
  }

  handleUserSelected = (user) => {
    this.props.actions.selectUser(user);
    this.props.actions.push('/users/edit');
  }

  render() {
    const {userListValid, userList} = this.props;
    return (
      <div className="container-fluid main" id="main">
        <div className="row">
          <div className="col-lg-12">
            <h1 className="float-left">{I18n.t('USERS')}</h1>
            <Link to="/users/create" className="btn btn-primary float-right create">{I18n.t('CREATE_USER')}</Link> 
          </div>
          {!userListValid && <div className="loading"/>} 
        </div>
        {userListValid &&
        <div className="row">
          <UserTable userList={userList} onSelected={this.handleUserSelected}/>
        </div>}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isMasterUser: isMasterUser(state),
    userList: getUsers(state),
    userListValid: areUsersValid(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({getAllUsers, push, selectUser}, dispatch)
  };
}

UsersPage.propTypes = {
  actions: PropTypes.object.isRequired,
  isMasterUser: PropTypes.bool.isRequired,
  userList: PropTypes.array.isRequired,
  userListValid: PropTypes.bool.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(UsersPage);


/** WEBPACK FOOTER **
 ** ./src/modules/users/components/UsersPage.js
 **/